import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'

const root = createRoot(document.getElementById('root')!)

if (import.meta.env.DEV && window.location.pathname === '/lab/3d-quality') {
  import('./views/Visual3DQualityLab').then(({ Visual3DQualityLab }) => root.render(<StrictMode><Visual3DQualityLab /></StrictMode>))
} else {
  root.render(<StrictMode><App /></StrictMode>)
}
